import { TrackedEvents, trackEvent } from 'analytics';
import { AIModelChoices, type PETComposition, type QualityReport } from 'api';
import { formatDate } from 'date';
import { Trans, useTranslation } from 'i18n';
import { useNavigate } from 'react-router-dom';
import { DataCard, ExpandableIconButton, Typography } from 'ui';
import { ImageOutlined, Insights } from 'ui/icons';

import { PETCompositionBreakdown } from '../../../breakdowns';

export const PETCompositionQualityReportDataCard = ({
  isLoading,
  balesAnalysed,
  latestInspection,
  composition,
  hasMedia,
  modelName,
}: {
  isLoading?: boolean;
  balesAnalysed: number;
  latestInspection: QualityReport['latest_inspection'];
  composition: PETComposition | null;
  hasMedia: boolean;
  modelName?: AIModelChoices;
}) => {
  const { t } = useTranslation('features');
  const navigate = useNavigate();

  const handleClickMedia = () => {
    trackEvent(TrackedEvents.QUALITY_REPORT_CLICK_CATEGORY_IMAGES, {
      category: 'AI Bale Analysis',
    });
    navigate('media?tab=accepted');
  };

  return (
    <DataCard
      isLoading={isLoading}
      slotProps={{
        header: {
          action: hasMedia ? (
            <ExpandableIconButton
              icon={<ImageOutlined />}
              label={t('dataCards.petCompositionQualityReport.actions.showMedia')}
              onClick={handleClickMedia}
            />
          ) : undefined,
          avatar: <Insights />,
          title: t('dataCards.petCompositionQualityReport.title'),
        },
      }}
    >
      <DataCard.Item colSpan={12}>
        <Typography
          variant="body1"
          color="secondary"
          sx={{
            paddingBottom: 2,
          }}
        >
          <Trans
            i18nKey="dataCards.petCompositionQualityReport.description"
            namespace="features"
            components={{ bold: <b /> }}
          />
        </Typography>
      </DataCard.Item>
      <DataCard.Item title={t('dataCards.petCompositionQualityReport.fields.supplierBalesAnalysed')} colSpan={4}>
        {balesAnalysed}
      </DataCard.Item>
      {latestInspection ? (
        <DataCard.Item title={t('dataCards.petCompositionQualityReport.fields.latestInspection')} colSpan={8}>
          {formatDate(latestInspection)}
        </DataCard.Item>
      ) : null}
      <DataCard.Item colSpan={12}>
        {composition ? <PETCompositionBreakdown composition={composition} modelName={modelName} /> : null}
      </DataCard.Item>
    </DataCard>
  );
};
